<template>
    <div class="input input--file">
        <div class="form-group">
            <input
                type="file"
                :name="name"
                :multiple="multiple"
                :accept="accept"
                @change="emit('fileUpdated', $event.target.files)"
            />
        </div>

        <p class="form-error" v-if="error" role="alert" aria-live="assertive">
            {{ error }}
        </p>
    </div>
</template>

<script setup>
const props = defineProps({
    name: String,
    multiple: {
        type: Boolean,
        default: false,
    },
    error: String,
    accept: String
})

const emit = defineEmits(['fileUpdated'])
</script>